import BankAccountAddPage from './BankAccountAddPage';

export default BankAccountAddPage;
